import React, { useContext, lazy, Suspense } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';

const Plan = lazy(() => import(/* webpackChunkName: "Plan" */ '@mirinae/members/pages/Plan'));
const Payment = lazy(() => import(/* webpackChunkName: "Payment" */ '@mirinae/members/pages/Payment'));
const MyAccount = lazy(() => import(/* webpackChunkName: "MyAccount" */ '@mirinae/members/pages/MyAccount'));
const CancelSubscription = lazy(() => import(/* webpackChunkName: "CancelSubscription" */ '@mirinae/members/pages/CancelSubscription'));
import LoadingSpinner from '@mirinae/react-ui/components/spinner/LoadingSpinner';
import { UserContext } from '@mirinae/react-auth';
import { getUserType } from '@mirinae/defines/datas';

import { localPaths } from '@mirinae/members/modules/defines/paths';
import { ExternalRedirector, membersPaths } from '@mirinae/defines/paths';

const MembersRoutes = () => {
    const [userContext] = useContext(UserContext);
    const userType = getUserType(userContext.user);

    return (
        <Suspense fallback={LoadingSpinner}>
            <Routes>
                <Route path={localPaths.home} element={userType === 'guest' ? <Plan /> : <MyAccount />} exact />
                <Route path={localPaths.plan} element={<Plan />} exact />
                <Route path={localPaths.payment} element={<Payment />} exact />
                <Route path={`${localPaths.payment}/:code`} element={<Payment />} />
                {/* <Route path={localPaths.profile} element={<MyAccount />} exact /> */}
                <Route path={localPaths.profile} element={<Navigate to={membersPaths.accountSetting} />} exact />
                <Route path={localPaths.subscription} element={<MyAccount />} exact />
                <Route path={localPaths.accountSetting} element={<MyAccount />} exact />
                <Route path={localPaths.cancelSubscription} element={<CancelSubscription />} exact />

                {/*<Route path="*" element={<ExternalRedirector to="/404.html" reload={true}/>} />*/}
                <Route path="*" element={ <Plan />} />
            </Routes>
        </Suspense>
    );
};

export default MembersRoutes;